import I18n from "../base/i18n.js";
/**
 * Class described enums: fixed lists of values for dropdown menus, select pickers etc.
 * For example, ordering directions can be described as enum with two available values: "ascending" and "descending"
 * @name BaseEnum
 * @class
 * @abstract
*/
export default class BaseEnum {

  /**
   * Name of enum in i18n file. Use for translate enum values. Must be overridden in inheritor
   * @abstract
   * @returns {string}
  */
  name() {
    return "";
  }

  /**
   * Available enum values. Must be overridden in inheritor
   * @abstract
   * @returns {Array.<string>}
  */
  rawValues() {
    return [];
  }

  /**
   * @private
   * @abstract
  */
  values() {
    let result = {};
    this.rawValues().forEach((rawValue) => {
      result[rawValue] = {
        value: rawValue,
        label: I18n.t(`enum.${this.name()}.${rawValue}`)
      }
    });
    return result;
  }

  /**
   * Translate enum value to human readable string
   * @param {string} value enum value
   * @returns {string}
  */
  label(value) {
    if(!value) {
      return "-";
    }
    let enumValue = this.values()[value];
    if(!enumValue) {
      return "-";
    }
    return enumValue.label;
  }
}